<template>
  <v-app class="transaction-success">
    <div class="d-flex justify-end pa-4">
      <LocaleSelect />
    </div>
    <v-main>
      <v-container class="transaction-success fill-height">
        <v-row justify="center" align="center" class="fill-height">
          <v-col cols="12" md="6" lg="4">
            <v-card elevation="4" class="pa-8">
              <div class="text-center">
                <v-icon color="success" size="100" class="mb-6">mdi-check-circle</v-icon>
                <h2 class="text-h4 font-weight-medium mb-4">
                  {{ $t('global.transaction.successTitle') || 'Payment Successful!' }}
                </h2>
                <p class="text-body-1 text--secondary mb-8">
                  {{
                    $t('global.transaction.successMessage') ||
                    'Your payment has been processed successfully.'
                  }}
                </p>
                <p class="text-caption text--disabled mb-4">
                  {{ $t('global.transaction.redirectingMessage') }}
                </p>
                <v-btn color="primary" large block @click="goToDashboard" class="mt-4">
                  <v-icon left>mdi-arrow-left</v-icon>
                  {{
                    deviceId
                      ? $t('global.transaction.returnToDevice')
                      : $t('global.transaction.goToDashboard')
                  }}
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import LocaleSelect from '@/components/LocaleSelect'

export default {
  name: 'TransactionSuccess',
  components: { LocaleSelect },
  data() {
    return {
      deviceId: null,
    }
  },
  created() {
    // Ensure store is properly initialized
    if (!this.$store.state.locale) {
      this.$store.commit('changeLocale', 'en')
    }
  },
  mounted() {
    const transactionId = this.$route.query.transId
    this.deviceId = this.$route.query.deviceId

    if (!transactionId) {
      console.warn('No transactionId found in route params')
    }
    // Payment was already processed by the webhook
    // This page just displays the success state
    console.log('Payment successfully processed for transaction:', transactionId)

    // Check if we have a device ID from the URL
    if (this.deviceId) {
      // Redirect to device page with success parameter after a short delay
      setTimeout(() => {
        // Encode the device ID in Relay format (Base64 of "Device:id")
        const encodedDeviceId = btoa(`Device:${this.deviceId}`)
        // Use the full URL path to redirect - works for any environment
        const baseUrl = window.location.origin
        window.location.href = `${baseUrl}/app/device/${encodedDeviceId}?paymentSuccess=true`
      }, 3000) // 3 second delay to show success message
    }
  },
  methods: {
    goToDashboard() {
      if (this.deviceId) {
        // Encode the device ID in Relay format (Base64 of "Device:id")
        const encodedDeviceId = btoa(`Device:${this.deviceId}`)
        const baseUrl = window.location.origin
        window.location.href = `${baseUrl}/app/device/${encodedDeviceId}?paymentSuccess=true`
      } else {
        const baseUrl = window.location.origin
        window.location.href = `${baseUrl}/app`
      }
    },
  },
}
</script>

<style lang="less" scoped>
.transaction-success {
  background-color: #f5f5f5;
}
</style>
